import './styles/main.scss'
import fvBg from './assets/fv-bg.png'
import fvImg from './assets/fv-img.png'
import tue from './assets/TUE.svg'
import logo from './assets/kotora-logo.svg'
import aboutImg from './assets/about-img.png'
import OnishiR from './assets/onishi-maru.png'
import footerBg from './assets/footer-bg.png'
import dotBg from './assets/dot-bg.png'
import spNavBtn from './assets/sp-nav-btn.svg'
import {gsap} from 'gsap'
import scrollFade from './js/scrollfade'
import timeLine from './js/timeline'
import {spNav,colorChange,smoothScroll,backtoTop,newsLink,accordion} from './js/navigation'

scrollFade()
timeLine()
colorChange()
spNav()
smoothScroll()
backtoTop()
newsLink()
accordion()




